export default __webpack_public_path__ + "static/coronini_img3-62a0333f28ef79900b2127df4a75eb72.png";